import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import LanguagePicker from '../LanguagePicker';
import { LocaleContext } from '../locale-context';
import AuthUserContext from '../session/AuthUserContext';

export default class MobileHeader extends React.Component {
    state = {
        isChecked: false
    };

    unCheck = () => {
        document.getElementById('navi-toggle').checked = false;
        this.setState({ isChecked: false });
    };

    handleChangeChk = e => {
        const isChecked = e.target.checked;
        this.setState({ isChecked: isChecked });
    };
    
    render() {
        const isChecked = this.state.isChecked;

        return (
            <LocaleContext.Consumer>
                {value => (
                    <div className="navigation">
                        <input
                            type="checkbox"
                            className="navigation__checkbox"
                            id="navi-toggle"
                            onChange={this.handleChangeChk}
                        />

                        <label
                            htmlFor="navi-toggle"
                            className="navigation__button"
                        >
                            <span className="navigation__icon">&nbsp;</span>
                        </label>

                        <div className="navigation__background">&nbsp;</div>
                        {!isChecked ? (
                            ''
                        ) : (
                            <nav className="navigation__nav">
                                <ul
                                    className="navigation__list"
                                    onClick={this.unCheck}
                                >
                                    <li
                                        className="navigation__item"
                                        id="navi_list"
                                    >
                                        <NavLink
                                            to="/"
                                            exact={true}
                                            className="navigation__link"
                                        >
                                            {value === 'en' ? 'Home' : 'Acasa'}
                                        </NavLink>
                                    </li>

                                    <li className="navigation__item">
                                        <NavLink
                                            to="/blog"
                                            exact={true}
                                            className="navigation__link"
                                        >
                                            Blog
                                        </NavLink>
                                    </li>

                                    <li className="navigation__item">
                                        <NavLink
                                            to="/services"
                                            exact={true}
                                            className="navigation__link"
                                        >
                                            {value === 'en'
                                                ? 'Services'
                                                : 'Servicii'}
                                        </NavLink>
                                    </li>

                                    <li className="navigation__item">
                                        <NavLink
                                            to="/testimonials"
                                            exact={true}
                                            className="navigation__link"
                                        >
                                            {value === 'en'
                                                ? 'Testimonials'
                                                : 'Ce Spun Altii'}
                                        </NavLink>
                                    </li>

                                    <li className="navigation__item">
                                        <NavLink
                                            to="/contact"
                                            exact={true}
                                            className="navigation__link"
                                        >
                                            Contact
                                        </NavLink>
                                    </li>
                                    <AuthUserContext.Consumer>
                                        {authUser =>
                                            authUser ? (
                                                <li className="navigation__item">
                                                    <NavLink
                                                        to="/blogmanagement"
                                                        exact={true}
                                                        className="navigation__link"
                                                    >
                                                        Blog Management
                                                    </NavLink>
                                                </li>
                                            ) : (
                                                ''
                                            )
                                        }
                                    </AuthUserContext.Consumer>
                                    <LanguagePicker
                                        changeLanguage={
                                            this.props.changeLanguage
                                        }
                                    />
                                </ul>
                            </nav>
                        )}
                    </div>
                )}
            </LocaleContext.Consumer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/MobileHeader.js